import { StatusSinistro } from "../StatusSinistro";
import { EnumValue } from "./enum-value";

export const StatusSinistroEnum = {
    pendente: 'PENDENTE',
    finalizado: 'FINALIZADO'
}

export const StatusSinistroValues: EnumValue[] = [
    {
        codigo: StatusSinistroEnum.pendente,
        descricao: 'Pendente'
    },
    {
        codigo: StatusSinistroEnum.finalizado,
        descricao: 'Finalizado'
    }
]

export const getStatusSinistroLabel = (tipo: StatusSinistro): string => {
    const match = StatusSinistroValues.find(
      value => value.codigo === tipo
    );
    return match ? match.descricao : '';
  };

export const getOptionsStatusSinistro = [
    {
      key: StatusSinistroEnum.pendente,
      value: StatusSinistroEnum.pendente,
      label: 'Física'
    },
    {
      key: StatusSinistroEnum.finalizado,
      value: StatusSinistroEnum.finalizado,
      label: 'Jurídica'
    }
  ];